import apiClient from "../../../services/apiClient";
import API_ENDPOINTS from "../../../config/apiEndpoints";
import { fetchSiteLookup } from "../../../services/lookupService";

const pickField = (obj, ...keys) => {
  if (!obj || typeof obj !== "object") return "";
  for (const key of keys) {
    const value = obj[key];
    if (value != null && String(value).trim() !== "") {
      return String(value).trim();
    }
  }
  return "";
};

export function getStudyAssociatedSitesLabel(studyDetails) {
  if (!studyDetails || typeof studyDetails !== "object") return "N/A";
  const mapped = pickField(studyDetails, "MappedSiteNames", "mappedSiteNames");
  if (mapped) return mapped;
  const siteName = pickField(studyDetails, "SiteName", "siteName");
  if (siteName) return siteName;
  return "N/A";
}

const siteNamesFromIds = (mappedIds, siteList) => {
  if (!mappedIds) return "";
  return mappedIds
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean)
    .map((id) => {
      const site = (siteList || []).find(
        (row) => String(row.SiteId).toLowerCase() === id.toLowerCase(),
      );
      return site?.SiteName || "";
    })
    .filter(Boolean)
    .join(", ");
};

/** Fill MappedSiteNames from GetStudyInfo + site lookup when eISF load omits them. */
export async function resolveStudyAssociatedSites(studyRow, userData) {
  if (!studyRow?.StudyId || !userData?.OrganizationId) return studyRow;
  if (getStudyAssociatedSitesLabel(studyRow) !== "N/A") return studyRow;

  try {
    let mappedIds = pickField(studyRow, "MappedSiteIds", "mappedSiteIds");
    let mappedNames = pickField(studyRow, "MappedSiteNames", "mappedSiteNames");

    if (!mappedIds) {
      const studyRes = await apiClient.post(API_ENDPOINTS.STUDY.STUDY_ACTIVITY, {
        OrganizationId: userData.OrganizationId,
        CreatedBy: userData.StaffId,
        StudyId: studyRow.StudyId,
        Action: "GetStudyInfo",
      });

      const info = studyRes?.data?.StudyInfo?.[0] || {};
      mappedIds = pickField(info, "MappedSiteIds", "mappedSiteIds") || mappedIds;
      mappedNames =
        pickField(info, "MappedSiteNames", "mappedSiteNames") || mappedNames;
    }

    if (mappedNames) {
      return {
        ...studyRow,
        MappedSiteIds: mappedIds,
        MappedSiteNames: mappedNames,
      };
    }

    if (mappedIds) {
      const siteList = await fetchSiteLookup(userData);
      const names = siteNamesFromIds(mappedIds, siteList);
      if (names) {
        return {
          ...studyRow,
          MappedSiteIds: mappedIds,
          MappedSiteNames: names,
        };
      }
    }
  } catch (error) {
    console.warn("Could not resolve study associated sites:", error);
  }

  return studyRow;
}
